/**
 * Created by Sasha on 7/25/2018.
 */
import moment from 'moment';
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Observable , BehaviorSubject} from 'rxjs';
import {AppConfig} from '../../app.config';
import {TranslateService} from '@ngx-translate/core';
@Injectable()
export class UserService {
  static InjectorInstance: HttpClient;
  static Config: AppConfig;

  users: any[];
  onUsersChanged: BehaviorSubject<any> = new BehaviorSubject({});
  countryId = '';
  citiesId = [];
  organizationonsId = [];
  rolesId = [];
  activated: any = '';
  recommendator: any = '';
  addSuccess = false;
  updateSuccess = false;

  static checkEmail (email) {
    return UserService.InjectorInstance.get(UserService.Config.baseUrl + '/user/checkEmail?email=' + email ,
      UserService.Config.jsonTokenHeaders);
  }


  constructor (private http: HttpClient , private api: AppConfig,
               public translate: TranslateService) {
    UserService.InjectorInstance = this.http;
    UserService.Config = this.api;
  }


  // /**
  //  * Resolve
  //  * @param {ActivatedRouteSnapshot} route
  //  * @param {RouterStateSnapshot} state
  //  * @returns {Observable<any> | Promise<any> | any}
  //  */
  // resolve (route: ActivatedRouteSnapshot , state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
  //
  //   return new Promise((resolve , reject) => {
  //
  //     Promise.all([
  //       this.countryId = '' ,
  //       this.citiesId = [] ,
  //       this.rolesId = [] ,
  //       this.organizationonsId = [] ,
  //       this.activated = '' ,
  //       this.getUsers()
  //     ]).then(
  //       () => {
  //         resolve();
  //       } ,
  //       reject
  //     );
  //   });
  // }

  // getUsers () {
  //   return new Promise((resolve , reject) => {
  //     this.http.get(this.api.baseUrl + '/user/users?countryId=' + this.countryId +
  //       '&citiesId=' + this.citiesId.toString() + '&rolesId=' + this.rolesId.toString() +
  //       '&organizationsId=' + this.organizationonsId.toString() + '&activated=' + this.activated ,
  //       this.api.jsonTokenHeaders)
  //       .subscribe((response: any) => {
  //         this.users = response;
  //         this.onUsersChanged.next(this.users);
  //         resolve(response);
  //       } , reject);
  //   });
  // }

  getUsersNew (page = 1, perPage = 50, sort = 'name', direction = 'ASC', search = '') {
    return this.http.get(this.api.baseUrl + '/user/usersNew?countryId=' + this.countryId +
        '&citiesId=' + this.citiesId.toString() + '&rolesId=' + this.rolesId.toString() +
        '&organizationsId=' + this.organizationonsId.toString() + '&activated=' + this.activated +
      '&recommendator=' + this.recommendator + '&page=' + page + '&perPage=' + perPage + '&sort=' + sort +
      '&direction=' + direction + '&search=' + search,
        this.api.jsonTokenHeaders);
  }

  getUserById (id) {
    return this.http.get(this.api.baseUrl + '/user/user?id=' + id , this.api.jsonTokenHeaders);
  }

  deleteCanton (id) {
    return this.http.delete(this.api.baseUrl + '/city/deleteCity?id=' + id , this.api.jsonTokenHeaders);
  }
  getRoles () {
    return this.http.get(this.api.baseUrl + '/role/roles' , this.api.jsonTokenHeaders);
  }

  addUser (data) {
    const formData: FormData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key) && data[ key ] !== null) {
        formData.append(key , data[ key ]);
      }
    }
    if (data.hasOwnProperty('isMainAdmin')) {
      formData.delete('isMainAdmin');
      formData.append('isMainAdmin' , data.isMainAdmin ? '1' : '0');
    }

    if (data.hasOwnProperty('canRecommend')) {
      formData.delete('canRecommend');
      formData.append('canRecommend' , data.canRecommend ? '1' : '0');
    }

    if (data.hasOwnProperty('isSecretariat')) {
      formData.delete('isSecretariat');
      formData.append('isSecretariat' , data.isSecretariat ? '1' : '0');
    }

    if (data.hasOwnProperty('isSafeguard')) {
      formData.delete('isSafeguard');
      formData.append('isSafeguard' , data.isSafeguard ? '1' : '0');
    }

    return this.http.post(this.api.baseUrl + '/user/addUser' , formData , this.api.formDataHeaders);
  }

  sendEmail (data) {
    return this.http.post(this.api.baseUrl + '/user/upload' , data , this.api.jsonTokenHeaders);
  }

  checkEmailValid (email) {
    return this.http.get(this.api.baseUrl + '/user/checkEmail?email=' + email , this.api.jsonTokenHeaders);
  }

  checkOrgMainAdmin (userId, orgId) {
    return this.http.get(this.api.baseUrl + '/user/checkOrgMainAdmin?userId=' + userId + '&orgId=' + orgId,
      this.api.jsonTokenHeaders);
  }

  checkOldPassword (password) {
    return this.http.get(this.api.baseUrl + '/user/checkPassword?password=' + password , this.api.jsonTokenHeaders);
  }

  getProfileData () {
    return this.http.get(this.api.baseUrl + '/user/profileData' , this.api.jsonTokenHeaders);
  }

  updatePassword (email , password) {
    const data = {
      email , password
    };
    return this.http.post(this.api.baseUrl + '/user/changePass' , data ,
      this.api.jsonTokenHeaders);
  }

  updateProfile (profileData) {
    return this.http.post(this.api.baseUrl + '/user/changeProfile' , profileData , this.api.jsonTokenHeaders);
  }

  changeLogo (image) {
    const formData: any = new FormData();
    formData.append('file' , image);

    return this.http.post(this.api.baseUrl + '/user/changeLogo' , formData , this.api.formDataHeaders);
  }

  blockUser (data) {
    return this.http.post(this.api.baseUrl + '/user/blockUser' , data , this.api.jsonTokenHeaders);
  }

  setCountryId (id) {
    this.countryId = id;
    this.citiesId = [];
    this.organizationonsId = [];
  }

  setCities (city) {
    if (city.selected) {
      this.citiesId.push(+city.canton);
    } else {
      const index = this.citiesId.indexOf(+city.canton);
      if (index !== -1) {
        this.citiesId.splice(index , 1);
      }
    }
    const uniqueArr = new Set(this.citiesId);
    this.citiesId = [...uniqueArr];
    this.organizationonsId = [];
  }

  getCities () {
    return this.citiesId;
  }

  setOrganizations (organization) {
    if (organization.selected) {
      this.organizationonsId.push(+organization.organization);
    } else {
      const index = this.organizationonsId.indexOf(+organization.organization);
      if (index !== -1) {
        this.organizationonsId.splice(index , 1);
      }
    }
    const uniqueArr = new Set(this.organizationonsId);
    this.organizationonsId = [...uniqueArr];
  }

  getOrganizations () {
    return this.organizationonsId;
  }

  setRoles (roles) {
    if (roles.selected) {
      this.rolesId.push(+roles.role);
    } else {
      const index = this.rolesId.indexOf(+roles.role);
      if (index !== -1) {
        this.rolesId.splice(index , 1);
      }
    }
    const uniqueArr = new Set(this.rolesId);
    this.rolesId = [...uniqueArr];
  }

  getRolesIds () {
    return this.rolesId;
  }

  setActivated (activated) {
    if (activated) {
      this.activated = 1;
    } else {
      this.activated = '';
    }
  }
  setRecommendator (recommendator) {
    if (recommendator) {
      this.recommendator = 1;
    } else {
      this.recommendator = '';
    }
  }

  getActivated () {
    return this.activated;
  }

  setToAll () {
    this.countryId = '';
    this.citiesId = [];
    this.rolesId = [];
    this.organizationonsId = [];
    this.activated = '';
    this.recommendator = '';
  }

  getOrganizationByCantons () {
    return this.http.get(this.api.baseUrl + '/organization/organizationByCantons?cantons=' + this.citiesId.toString() , this.api.jsonTokenHeaders);
  }


  confirmPrivacy () {
    return this.http.post(this.api.baseUrl + '/user/privacy' , {} , this.api.jsonTokenHeaders);
  }

  getFilter (type) {
    return this.http.get(this.api.baseUrl + '/filter/filter?type=' + type , this.api.jsonTokenHeaders);
  }

  setFilters (type , config , id?) {
    let data: any = {
      type: type ,
      config: JSON.stringify(config)
    };
    if (id) {
      data.id = id;
    }
    return this.http.post(this.api.baseUrl + '/filter/addFilter' , data , this.api.jsonTokenHeaders);
  }

  deleteUser (id) {
    return this.http.get(this.api.baseUrl + '/user/deleteUser?id=' + id , this.api.jsonTokenHeaders);
  }


  getDocumentation (section) {
    let lang = this.translate.currentLang;
    return this.http.get(this.api.baseUrl + '/documentation/documentation?section=' + section +
      '&lang=' + lang, this.api.jsonTokenHeaders);
  }

  addDocumentation (data) {
    return this.http.post(this.api.baseUrl + '/documentation/addDocumentation' , data , this.api.jsonTokenHeaders);
  }

  updateSort (data) {
    return this.http.post(this.api.baseUrl + '/documentation/updateSort' , data , this.api.jsonTokenHeaders);
  }

  getTutorial () {
    let lang = this.translate.currentLang;
    return this.http.get(this.api.baseUrl + '/documentation/tutorials?lang=' + lang , this.api.jsonTokenHeaders);
  }

  addTutorial (data) {
    return this.http.post(this.api.baseUrl + '/documentation/addTutorial' , data , this.api.jsonTokenHeaders);
  }
  deleteTutorial (id) {
    return this.http.post(this.api.baseUrl + '/documentation/deleteTutorial?id=' + id  , this.api.jsonTokenHeaders);
  }
  sendEmailPass (id) {
    return this.http.get(this.api.baseUrl + '/user/sendPassEmail?id=' + id , this.api.jsonTokenHeaders);
  }
  getMails (lang, platformId) {
    return this.http.get(this.api.baseUrl + '/mail/mails?lang=' + lang + '&platformId=' + platformId, this.api.jsonTokenHeaders);
  }

  getDefault (lang, platformId) {
    return this.http.get(this.api.baseUrl + '/dynamicData/defaultData?lang=' + lang + '&platformId=' + platformId , this.api.jsonTokenHeaders);
  }
  saveMail (data) {
    return this.http.post(this.api.baseUrl + '/mail/addMail', data  , this.api.jsonTokenHeaders);
  }

  addDynamicData (data) {
    return this.http.post(this.api.baseUrl + '/dynamicData/addDynamicData', data  , this.api.jsonTokenHeaders);
  }
  privacyAdmin (lang) {
    return this.http.get(this.api.baseUrl + '/dynamicData/privacyAdmin?lang=' + lang  , this.api.jsonTokenHeaders);
  }
  getDynamicDataById(id) {
    return this.http.get(this.api.baseUrl + '/dynamicData/dynamicData?id=' + id, this.api.jsonTokenHeaders);
  }

  getGeneralDashboardInfo (orgId, isTime) {
    return this.http.get(this.api.baseUrl + '/dashboard/general?orgId=' + orgId + '&isTime=' + isTime  , this.api.jsonTokenHeaders);
  }

  getEventsDashboardInfo (orgId, isTime) {
    return this.http.get(this.api.baseUrl + '/dashboard/events?orgId=' + orgId + '&isTime=' + isTime  , this.api.jsonTokenHeaders);
  }

  getCommunicationsDashboardInfo (orgId, isTime) {
    return this.http.get(this.api.baseUrl + '/dashboard/communications?orgId=' + orgId + '&isTime=' + isTime  , this.api.jsonTokenHeaders);
  }

  getSubscriptionsDashboardInfo (orgId, isTime) {
    return this.http.get(this.api.baseUrl + '/dashboard/subscriptions?orgId=' + orgId + '&isTime=' + isTime  , this.api.jsonTokenHeaders);
  }

  getRewardsDashboardInfo (orgId, isTime) {
    return this.http.get(this.api.baseUrl + '/dashboard/rewards?orgId=' + orgId + '&isTime=' + isTime  , this.api.jsonTokenHeaders);
  }
  getStatusDashboardInfo (orgId, isTime) {
    return this.http.get(this.api.baseUrl + '/dashboard/status?orgId=' + orgId + '&isTime=' + isTime  , this.api.jsonTokenHeaders);
  }

  getOrganization () {
    return this.http.get(this.api.baseUrl + '/dashboard/organization' , this.api.jsonTokenHeaders);
  }

  updateNotification (data) {
    return this.http.post(this.api.baseUrl + '/notification/addNotification', data  , this.api.jsonTokenHeaders);
  }

  deleteDynamicData(id) {
    return this.http.delete(this.api.baseUrl + '/dynamicData/deleteDynamicData?id=' + id , this.api.jsonTokenHeaders);
  }

  updateLastSeen () {
    return this.http.post(this.api.baseUrl + '/user/updateLastSeen', {}  , this.api.jsonTokenHeaders);
  }
}
